export const doubleBreaksToParagraphs = (text = '') =>
  text
    .replace(/\n/g, '<br>')
    .split(/<br\/?>(?:\s*<br\/?>)+/gi)
    .map((par) => (par.startsWith('<p>') ? par : `<p>${par}</p>`))
    .join('')
